export function DuplicateRuleIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.88818 5.86139C3.88818 5.3505 4.09114 4.86053 4.45239 4.49927C4.81365 4.13801 5.30362 3.93506 5.81452 3.93506H12.0738C12.3268 3.93506 12.5773 3.98488 12.811 4.08169C13.0447 4.1785 13.2571 4.32039 13.436 4.49927C13.6148 4.67815 13.7567 4.8905 13.8535 5.12422C13.9503 5.35793 14.0002 5.60842 14.0002 5.86139V12.1207C14.0002 12.3737 13.9503 12.6242 13.8535 12.8579C13.7567 13.0916 13.6148 13.304 13.436 13.4828C13.2571 13.6617 13.0447 13.8036 12.811 13.9004C12.5773 13.9972 12.3268 14.047 12.0738 14.047H5.81452C5.56155 14.047 5.31105 13.9972 5.07734 13.9004C4.84363 13.8036 4.63127 13.6617 4.45239 13.4828C4.27352 13.304 4.13162 13.0916 4.03482 12.8579C3.93801 12.6242 3.88818 12.3737 3.88818 12.1207V5.86139Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.73095 10.9689C1.50946 10.8426 1.32523 10.6601 1.19688 10.4398C1.06853 10.2195 1.00061 9.96925 1 9.71429V2.49144C1 1.69693 1.65006 1.04688 2.44457 1.04688H9.66742C10.2091 1.04688 10.5038 1.32495 10.7508 1.76916"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
